import * as React from "react";
import { connect } from "react-redux";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";
import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import LabeledInput from "../../LabeledInput";
import APIClient from "../../APIClient";
import { DocumentUploader } from "../../DocumentUploader";

import { loadApp } from "../actions";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

const mapUnderwriterStateToProps = (state, ownProps) => ({
  documents: ownProps.documents,
  documentType: ownProps.documentType,
  prompt: ownProps.prompt,
  onUpload: ownProps.onUpload,
  ownerEntityType: ownProps.ownerEntityType,
  ownerEntityID: ownProps.ownerEntityID,
  applicationID: ownProps.applicationID,
});

const mapUnderwriterDispatchToProps = (dispatch, ownProps) => ({
  updateApplication: (dispatchType, payload) => {
    loadApp(dispatch, payload.id);
  },
});

const UnderwriterDocumentUploader = connect(
  mapUnderwriterStateToProps,
  mapUnderwriterDispatchToProps,
)(DocumentUploader as any);

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class TitleHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);

    const titleCompany = props.app.contacts.title_company;
    const titleAgent = props.app.contacts.title_agent;

    this.state = {
      title_company: (titleCompany && titleCompany.name) || "",
      title_company_phone: (titleCompany && titleCompany.phone) || "",
      title_company_email: (titleCompany && titleCompany.email) || "",
      title_officer_name: (titleAgent && titleAgent.name) || "",
      title_officer_phone: (titleAgent && titleAgent.phone) || "",
      title_officer_email: (titleAgent && titleAgent.email) || "",
      title_instructions_sent_at: props.app.title_instructions_sent_at || "",
      title_order_number: props.app.title_order_number || "",
    };
  }

  componentWillReceiveProps(nextProps) {
    const titleCompany = nextProps.app.contacts.title_company;
    const titleAgent = nextProps.app.contacts.title_agent;

    this.setState({
      title_company: (titleCompany && titleCompany.name) || "",
      title_company_phone: (titleCompany && titleCompany.phone) || "",
      title_company_email: (titleCompany && titleCompany.email) || "",
      title_officer_name: (titleAgent && titleAgent.name) || "",
      title_officer_phone: (titleAgent && titleAgent.phone) || "",
      title_officer_email: (titleAgent && titleAgent.email) || "",
      title_instructions_sent_at: nextProps.app.title_instructions_sent_at || "",
      title_order_number: nextProps.app.title_order_number || "",
    });
  }

  handleOnChange(e) {
    const newState = {};
    newState[e.target.name] = e.target.value;
    this.setState(newState);
  }

  onSave() {
    APIClient.put(`/uw/${this.props.app.id}/title_contact`, {
      ...this.state,
      contact_source: "TitleHurdle",
    }).then((responseObject: any) => {
      loadApp(this.props.dispatch, this.props.app.id);
    });
  }

  render() {
    const { app, hurdle, onHide } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <div>
          Title Instructions Sent At: {this.state.title_instructions_sent_at} <br />
        </div>
        <ul>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_company"
              inputValue={this.state.title_company}
              labelValue="title_company"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_company_phone"
              inputValue={this.state.title_company_phone}
              labelValue="title_company_phone"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_company_email"
              inputValue={this.state.title_company_email}
              labelValue="title_company_email"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_officer_name"
              inputValue={this.state.title_officer_name}
              labelValue="title_officer_name"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_officer_phone"
              inputValue={this.state.title_officer_phone}
              labelValue="title_officer_phone"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_officer_email"
              inputValue={this.state.title_officer_email}
              labelValue="title_officer_email"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
          <li>
            <LabeledInput
              inputType="text"
              inputName="title_order_number"
              inputValue={this.state.title_order_number}
              labelValue="title_order_number"
              onChange={this.handleOnChange.bind(this)}
            />
          </li>
        </ul>

        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button kind="primary" onClick={this.onSave.bind(this)} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }
}

export default connect()(TitleHurdleEditor);
